module.exports = __webpack_public_path__ + "img/icon-software.9eaf9071.svg";